

<template>
    <div>
        <h1 class="font-bold my-10">
            {{ $t('nav.aboutAdvertisement') }}
        </h1>
        <p v-html="about_advertisement">
            
        </p>
    </div>
</template>

<script>
import api from '@/api';

export default {
    name: 'aboutAdvertisement',
    components: {
    },
    data(){
        return {
            loading: false,
            about_advertisement: []
        }
    },
    methods: {
        async getAboutAdvertisment(){
            this.loading = true
            try{ 
                const response = await api.get('info/')
                this.about_advertisement = response.data['about_advertisement']
            }
            catch(e){
                console.log(e)
            }
            this.loading = false

        }
    },
    computed: {

    },
    async created(){
        await this.getAboutAdvertisment()
    }
}
</script>